import React from 'react';
import './GPCONGallaryButton.css';

function GPCONGallaryButton() {
    const handleGallaryButton = () => {
        // Scroll to top smoothly
        window.scrollTo({ top: 0, behavior: "smooth" });

        // Open the mobile menu if it's closed
        const mobileMenu = document.querySelector('.mobile-menu'); // Change this selector based on your actual navbar
        if (mobileMenu && !mobileMenu.classList.contains('open')) {
            mobileMenu.classList.add('open'); // Add the class to open the menu
        }

        // Open the activity dropdown
        setTimeout(() => {
            const activitiesDropdown = document.querySelector('.menudropdown-content');
            if (activitiesDropdown) {
                activitiesDropdown.classList.add('show'); // Manually open dropdown
            }
        }, 500); // Delay ensures menu is open before opening dropdown
    };

    return (
        <div className="gpcon-gallary-body">
            <div className="GallaryButton" onClick={handleGallaryButton}>
                All Photos/Gallery
            </div>
            <div className='GallaryButton-Text'>
                <span>&nbsp;Relive the Best Moment &nbsp;</span>
            </div>
        </div>
    );
}

export default GPCONGallaryButton;
